import { render, staticRenderFns } from "./FutureTurnaround.vue?vue&type=template&id=667e178a&scoped=true&"
import script from "./FutureTurnaround.vue?vue&type=script&lang=ts&"
export * from "./FutureTurnaround.vue?vue&type=script&lang=ts&"
import style0 from "./FutureTurnaround.vue?vue&type=style&index=0&id=667e178a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e178a",
  null
  
)

export default component.exports